// 倒计时
function getRandomNum(min, max) {
  return Math.floor(Math.random() * (max - min)) + min;
}

let endTimeG;

function cutDownTime() {
  let nowTime = new Date();
  let endTime = new Date(endTimeG);

  let leftTime = endTime.getTime() - nowTime.getTime();
  if (leftTime < 0) {
    setupNewCountdown();
    leftTime = 0;
  }
  let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
    leftM = Math.floor((leftTime / (1000 * 60)) % 60),
    leftS = Math.floor((leftTime / 1000) % 60);
  leftH = leftH >= 10 ? leftH : "0" + leftH;
  leftM = leftM >= 10 ? leftM : "0" + leftM;
  leftS = leftS >= 10 ? leftS : "0" + leftS;

  return {
    hour: leftH,
    minute: leftM,
    second: leftS,
  };
}
function setupNewCountdown() {
  const randomHour = getRandomNum(1, 9);
  const currentTime = new Date();
  endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
}
let intervalId;

function getCutDownTime() {
  setupNewCountdown();
  if (intervalId) clearInterval(intervalId);
  intervalId = setInterval(function () {
    let cutDownTimeText = cutDownTime();
    $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
    $(".sp_top_cut_down .sp_left_view .sp_minute").html(cutDownTimeText.minute);
    $(".sp_top_cut_down .sp_left_view .sp_second").html(cutDownTimeText.second);
  }, 1000);
}

getCutDownTime();

jQuery("#nav0").slide({
  mainCell: ".nav-imgs",
  autoPlay: true,
  effect: "leftMarquee",
  interTime: 8,
  vis: 2,
  scroll: 2,
});

let swiper2 = new Swiper("#swiper2", {
  autoplay: true,
  autoplay: {
    disableOnInteraction: false,
  },
  loop: true,
  centeredSlides: true,
  spaceBetween: -60,
  slidesPerView: "auto",
  on: {
    slideChange: function (e) {
      $("#sp_btns p")
        .eq(e.realIndex)
        .addClass("active")
        .siblings()
        .removeClass("active");
    },
  },
});
// 点击切换轮播
$("#sp_btns p").click(function () {
  $(this).addClass("active").siblings().removeClass("active");
  swiper2.slideTo($(this).index());
});
new Swiper("#swiper3", {
  autoplay: true,
  autoplay: {
    disableOnInteraction: false,
  },
  loop: true,
  centeredSlides: true,
  spaceBetween: 40,
  slidesPerView: "auto",
});

// 页面内的尺码表切换事件
$(".sp-size-part .btn-wrap").click(function () {
  $(this).addClass("active").siblings().removeClass("active");
  let index = $(this).index();
  $(".sp-size-part .sp-size1").eq(index).show().siblings(".sp-size1").hide();
});
// 弹窗内尺码表切换
$(".sp-size-part2 .btn-wrap").click(function () {
  $(this).addClass("active").siblings().removeClass("active");
  let index = $(this).index();
  $(".sp-size-part2 .sp-size1").eq(index).show().siblings(".sp-size1").hide();
});
var thumbsp = new Swiper("#thumbs-p", {
  spaceBetween: 23,
  slidesPerView: 5,
  watchSlidesVisibility: true, //防止不可点击
});
let swiper = new Swiper("#swiper-p1", {
  thumbs: {
    swiper: thumbsp,
  },
  spaceBetween: 20,
  navigation: {
    prevEl: ".button-prev2",
    nextEl: ".button-next2",
  },
});
// 处理加入购物车事件
function handleAddToCart(num) {
  if (num > 0) {
    $(".sp-top-btn").addClass("sp-high");
    $(".sp-top-btn span").html("ZUR KASSE GEHEN");
    $(".sp-header-top .sp-cart").addClass("on");
  } else {
    $(".sp-top-btn").removeClass("sp-high");
    $(".sp-top-btn span").html("JETZT KAUFEN");
    $(".sp-header-top .sp-cart").removeClass("on");
  }
}
handleAddToCart(window.cartCount);

// 弹窗内尺码表切换
$(".sp-size-part2 .btn-wrap").click(function () {
  $(this).addClass("active").siblings().removeClass("active");
  let index = $(this).index();
  $(".sp-size-part2 .sp-size1").eq(index).show().siblings(".sp-size1").hide();
});

let prods = window.product;
function getCur(){
  let color = $('#sp-color div.active').attr('data-val')
  let size = $('#sp-size div.active').attr('data-val')
  return prods.filter(item=> item.option1 == color && item.option2 == size)[0]
}
function select1_id(){
  let color1 = $('.select-color1 ul li.active').attr('data-val')
  let size1 = $('.select-size1 ul li.active').attr('data-val')
  return prods.filter(item=> item.option1 == color1 && item.option2 == size1)[0]
}
function select2_id(){
  let color2 = $('.select-color2 ul li.active').attr('data-val')
  let size2 = $('.select-size2 ul li.active').attr('data-val')
  return prods.filter(item=> item.option1 == color2 && item.option2 == size2)[0]
}
function changePrice() {
  let num = $("#calcNumber").val();
  let price = (getCur().price / 100).toFixed(2);
  let compare = (getCur().compare_at_price / 100).toFixed(2);
  // if(num == 1){
  //   price = (getCur().price * num / 100).toFixed(2)
  // }else if(num == 2){
  //   price = (getCur().price * num / 100 * 0.95).toFixed(2)
  // }else if(num == 3){
  //   price = (getCur().price * num / 100 * 0.9).toFixed(2)
  // }else {
  //   price = (getCur().price * num / 100 * 0.85).toFixed(2)
  // }
  // price = (price + '').replace('.', ',')
  // compare = (compare + '').replace('.', ',')
  $(".product-infos .price-group .price1 span").html(price);
  $(".product-infos .price-group .price2 span").html(compare);
  let off_font =
    100 - Math.ceil((getCur().price / getCur().compare_at_price) * 100);
  $(".product-infos .price3 span").html(off_font);
}

$('.buyNow').click(function(){
  let num = $('#calcNumber').val()
  let check_index = $('.sp-check-btn div.active').index()
  if(check_index == 0){
    window.location.href = '/cart/' + getCur().id + ':' + num
  }else{
    window.location.href = '/cart/' + select1_id().id + ':' + num + ',' + select2_id().id + ':' + num
  }
})
$(".sp-reduce").click(function () {
  let input = $(this).siblings("input")[0];
  let num = Number(input.value) - 1;
  if (num > 0) {
    input.value = num;
  }
});
$(".sp-add").click(function () {
  let input = $(this).siblings("input")[0];
  let num = Number(input.value) + 1;
  input.value = num;
});
$(".sp-top-btn").click(function () {
  $.ajax({
    type: "POST",
    url: "/cart/",
    success: function () {
      $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
        let cartNum = result.item_count;
        let cartItem = result.items;
        let url = "/cart/";
        if (cartNum > 0) {
          cartItem.forEach(function (cartItem) {
            url += cartItem.id + ":" + cartItem.quantity + ",";
          });
          window.location.href = url;
        }
      });
    },
    dataType: "json",
  });
});

$(".reduce").click(function () {
  let input = $(this).siblings("input")[0];
  let num = Number(input.value) - 1;
  if (num > 0) {
    input.value = num;
  }
  changePrice();
});
$(".add").click(function () {
  let input = $(this).siblings("input")[0];
  let num = Number(input.value) + 1;
  input.value = num;
  changePrice();
});

// 商品弹窗状态
let _popShow = false;

// 展示尺码弹窗
$(".sp-size-btn").click(function () {
  $(".sp-mask").css("display", "flex");
  $(".sp-mask .size-pop").show();
  $(".sp-mask .img-pop").hide();
});

// 点击放大按钮
$(".sp-large,.p-img").click(function () {
  $(".sp-mask").css("display", "flex");
  let _index = $("#sp-color .active").index();

  $(".sp-mask .img-pop .sp-img")[0].src = $(".product-part .p-img")[0].src;

  $(".sp-mask .img-pop").css("display", "flex");
  $(".sp-mask .size-pop").hide();
});
// 点击页面内尺码表
$(".sp-size-part .sp-img").click(function () {
  $(".sp-mask").css("display", "flex");
  console.log($(this));
  $(".sp-mask .img-pop .sp-img")[0].src = $(this)[0].src;

  $(".sp-mask .img-pop").css("display", "flex");
  $(".sp-mask .size-pop").hide();
});

// 关闭弹窗按钮
$(".close-btn, .sp-close-pop").click(function () {
  $(".sp-mask").hide();
  // $(".sp-mask2").hide();
});

$(".sp-mask").click(function (e) {
  if ($(e.target).closest(".sp-mask .choose-btn").length > 0) {
  } else {
    $(".sp-mask").hide();
  }
});

let spImgList = [
  "https://cdn.shopify.com/s/files/1/0617/1154/8575/files/20240604-p-khaki.png",
  "https://cdn.shopify.com/s/files/1/0617/1154/8575/files/20240604-p-black.png",
  "https://cdn.shopify.com/s/files/1/0617/1154/8575/files/20240604-p-green.png",
  "https://cdn.shopify.com/s/files/1/0617/1154/8575/files/20240604-p-grey.png",
];
$(function () {
  $(".option").click(function () {
    $(this).siblings().removeClass("active");
    $(this).addClass("active");
    // style选项
    let colorOptions = $("#sp-color .option.active").index();

    let img0 = $(".p-img");

    img0[0].src = spImgList[colorOptions];
    changePrice();
  });
  let colorList = window.productOption[0].values;
  let modelList = window.productOption[1].values;

  // 模拟select-option
  $(".sp-select").click(function () {
    $(this).siblings(".select-opt").toggle();
  });

  $(".select-opt li").click(function () {
    let spimg = $(".product-part .sp-index2 .p-img");
    let _index = $(this).index();
    let _color = $(this).attr("data-color");
    let _parent = $(this).parent().parent().siblings(".sp-select");
    if (_parent.attr("data-type") == "spColor1") {
      _parent.html(
        `<span style="background: ${_color}"></span>${colorList[_index]}`
      );
      spimg[0].src = spImgList[_index];
    } else if (_parent.attr("data-type") == "spColor2") {
      _parent.html(
        `<span style="background: ${_color}"></span>${colorList[_index]}`
      );
      spimg[1].src = spImgList[_index];
    } else {
      _parent.text(modelList[_index]);
    }
    $(this).siblings().removeClass("active");
    $(this).addClass("active");
    $(".select-opt").hide();
  });
  // style选项
  $(".cart-btn").click(function () {
    $(this).children("img").addClass("on");
    setTimeout(function () {
      $(".cart-btn").children("img").removeClass("on");
    }, 500);
    $(".sp-header-top .sp-cart").addClass("on");
  });
  let spShopIndex = 0;
  $(".sp-check").click(function () {
    $(this).addClass("active").siblings().removeClass("active");
    spShopIndex = $(this).index();
    if (spShopIndex == 0) {
      $(".sp-index1").show();
      $(".sp-index2").hide();
      $("#sp_price1").html(prods[0].price / 100);
      $("#sp_price2").html(prods[0].compare_at_price / 100);
    } else {
      
      $(".sp-index1").hide();
      $(".sp-index2").show();

      $("#sp_price1").html('62.98');
      $("#sp_price2").html(
        ((prods[0].compare_at_price * 2 * 0.92) / 100).toFixed(2)
      );
    }
    $("#calcNumber").val(1);
  });

  // 点击放大按钮
  $(".sp-large,.p-img").click(function () {
    $(".sp-mask").css("display", "flex");
    let _img;
    if (spShopIndex == 0) {
      _img = $(".product-part .sp-index1 .p-img");
      $(".sp-mask .img-pop .sp-img")[0].src = _img[0].src;
    } else {
      _img = $(".product-part .sp-index2 .p-img");
      $(".sp-mask  .img-pop  .sp-img")[0].src = _img[0].src;
      $(".sp-mask  .img-pop  .sp-img")[1].src = _img[1].src;
    }

    $(".sp-mask .img-pop").css("display", "flex");
    $(".sp-mask .size-pop").hide();
  });
  $(".product-part .cart-btn").click(function () {
    // var img = $(".product-part .p-img");

    var img;
    if (spShopIndex == 0) {
      img = $(".product-part .sp-index1 .p-img");
      var data = {
        id: getCur().id,
        quantity: $("#calcNumber").val(),
      };
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: data,
        success: function () {
          $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
            $("#cardNum").html(result.item_count);
            handleAddToCart(Number($("#cardNum").text()));
          });
        },
        dataType: "json",
      });
    } else {
      img = $(".product-part .sp-index2 .p-img");
      let cardNum = Number($("#cardNum").html());
      $("#cardNum").html(cardNum + Number($("#calcNumber").val()) * 2);
      let formData = {
        items: [
          { id: select1_id().id, quantity: $("#calcNumber").val() },
          { id: select2_id().id, quantity: $("#calcNumber").val() },
        ],
      };
      handleAddToCart(Number($("#cardNum").text()));
      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((response) => {
          return response.json();
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    }
    
    var flyer = img[0].cloneNode(true);
    flyer.classList.add("sp_clone");

    $(".product-part").append(flyer);
    $(".sp_clone").css({
      width: img[0].width,
      height: img[0].height,
      position: "fixed",
      top: img[0].offsetTop,
      left: img.offset().left,
      "z-index": "99",
    });

    let finish = $(".sp-cart");
    $(".sp_clone").animate(
      {
        top: finish[0].offsetTop + $(".time-part").height(),
        left: finish[0].offsetLeft + finish.width() / 2,
        width: 50, // 结束时的大小，根据需要调整
        height: 50, // 结束时的大小，根据需要调整
        opacity: 0.4,
      },
      500,
      "linear",
      function () {
        $(this).animate(
          {
            width: 0,
            height: 0,
            opacity: 0,
          },
          0,
          function () {
            $(this).detach();
          }
        );
      }
    );
    // 另一个
    if (spShopIndex == 1) {
      var img2;

      img2 = $(".product-part .sp-index2 .p-img2");
      var flyer2 = img2[0].cloneNode(true);
      flyer2.classList.add("sp_clone2");

      $(".product-part").append(flyer2);
      $(".sp_clone2").css({
        width: img2[0].width,
        height: img2[0].height,
        position: "fixed",
        top: img2[0].offsetTop,
        left: img2.offset().left,
        "z-index": "99",
      });

      $(".sp_clone2").animate(
        {
          top: finish[0].offsetTop + $(".time-part").height(),
          left: finish[0].offsetLeft + finish.width() / 2,
          width: 50, // 结束时的大小，根据需要调整
          height: 50, // 结束时的大小，根据需要调整
          opacity: 0.4,
        },
        500,
        "linear",
        function () {
          $(this).animate(
            {
              width: 0,
              height: 0,
              opacity: 0,
            },
            0,
            function () {
              $(this).detach();
            }
          );
        }
      );
    }
  });
});

function mainRender() {
  $(function () {
    $("#root").css("zoom", "normal");
    let scale = document.body.clientWidth / 1080;
    $("#root").css("zoom", scale);

    window.addEventListener(
      "resize",
      (function () {
        var timer;
        return function () {
          if (timer) clearTimeout(timer);
          timer = setTimeout(function () {
            $("#root").css("zoom", "normal");
            let scale = document.body.clientWidth / 1080;
            $("#root").css("zoom", scale);
          }, 100);
        };
      })()
    );
  });

  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
    const config = {
      rootMargin: "0px 0px 1300px 0px",
      threshold: 0,
    };

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target;
          const dataSrc = image.getAttribute("data-src");
          image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image); // 停止观察该图片
        }
      });
    },
    config);

    images.forEach(function (image) {
      lazyLoadObserver.observe(image); // 开始观察每个图片
    });
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach((subArray) => {
        subArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      });
    } else {
      // 处理一维数组
      imageArray.forEach((url) => {
        const img = new Image();
        img.src = url;
      });
    }
  }
  let banner1List = [
    "https://cdn.shopify.com/s/files/1/0617/1154/8575/files/20240604-img1-1.jpg",
    "https://cdn.shopify.com/s/files/1/0617/1154/8575/files/20240604-img1-2.jpg",
    "https://cdn.shopify.com/s/files/1/0617/1154/8575/files/20240604-img1-3.jpg",
    "https://cdn.shopify.com/s/files/1/0617/1154/8575/files/20240604-img1-4.jpg",
    "https://cdn.shopify.com/s/files/1/0617/1154/8575/files/20240604-img1-5.jpg",
  ];
  let banner1List3 = [
    "https://cdn.shopify.com/s/files/1/0617/1154/8575/files/20240604-b1.jpg",
    "https://cdn.shopify.com/s/files/1/0617/1154/8575/files/20240604-b2.jpg",
    "https://cdn.shopify.com/s/files/1/0617/1154/8575/files/20240604-b3.jpg",
  ];
  let banner1List4 = [
    "https://cdn.shopify.com/s/files/1/0617/1154/8575/files/20240604-c1.jpg",
    "https://cdn.shopify.com/s/files/1/0617/1154/8575/files/20240604-c2.jpg",
    "https://cdn.shopify.com/s/files/1/0617/1154/8575/files/20240604-c3.jpg",
    "https://cdn.shopify.com/s/files/1/0617/1154/8575/files/20240604-c4.jpg",
  ];
  document.addEventListener("DOMContentLoaded", function () {
    lazyLoadImages();

    preloadImages(spImgList);
    preloadImages(banner1List);
    preloadImages(banner1List3);
    preloadImages(banner1List4);

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]');
    links.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop;
        window.scroll({
          top:
            offsetTop * $("div#root").css("zoom") -
            250 * $("div#root").css("zoom"),
          behavior: "smooth", // 使用 smooth 实现平滑滚动
        }); // 方式二
      });
    });
  });

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  var isAndroid = /android/i.test(userAgent);
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log("Android");
  } else if (isIOS) {
    console.log("iOS");
  } else if (isPC) {
    console.log("PC");
  } else {
    $(".sp_system").css("letter-spacing", "-4px");
  }
}

mainRender();
